module.exports = __webpack_public_path__ + "img/icon-plus.4b3daf4b.png";